import Vue from 'vue'

Vue.directive('focus', {
  inserted(el) {
    $(el).attr('autofocus', true);
    el.focus()
  }
})

Vue.directive('modalFocus', {
  inserted(el) {
    $(el).on('show.bs.modal', a => {
      setTimeout(() => {
        $(el).find('[autofocus]')[0].focus();
      }, 500);
    })
  }
})

Vue.directive('date', {
  bind(el) {
    $(el).datepicker({
      format: 'yyyy/mm/dd'
    });
  }
})

Vue.directive('required', {
  update(el) {
    $(el).rules('add', {
      required: true,
      messages: {
        required: "This is a required field"
      }
    });
  }
})

Vue.directive('number', {
  update(el) {
    $(el).rules('add', {
      number: true,
      messages: {
        required: "Please enter a valid number."
      }
    });
  }
})

Vue.directive('range', {
  update(el, binding) {
    $(el, binding).rules('add', {
      range: [binding.value.min, binding.value.max],
      messages: {
        required: `Please enter a value between ${binding.value.min} and ${binding.value.max}.`
      }
    });
  }
})

Vue.directive('digits', {
  update(el) {
    $(el).rules('add', {
      digits: true,
      messages: {
        required: "Please enter a valid digits."
      }
    });
  }
})

Vue.directive('checkbox', {
  inserted(el, binding) {
    let message = "This is a required field";
    if (binding.value.isRequired) {
      if (binding.value.message) {
        message = binding.value.message;
      }
      $(el, binding).rules('add', {
        required: true,
        messages: {
          required: message
        }
      });
    }
  }
})

Vue.directive('email', {
  update(el) {
    $(el).rules('add', {
      email: true,
      messages: {
        email: "This is a email field"
      }
    });
  }
})

Vue.directive('maxlength', {
  update(el, binding) {
    $(el).rules('add', {
      maxlength: binding.value,
      messages: {
        maxlength: `Please enter no more than ${binding.value} characters!`
      }
    });
  }
})

Vue.directive('name', {
  update(el) {
    $(el).rules('add', {
      regex: '^[^0-9]+$',
      messages: {
        regex: 'The field does not allow numbers'
      }
    });
  }
})

Vue.directive('phone', {
  update(el) {
    $(el).rules('add', {
      regex: '^[0-9() +-]*$',
      messages: {
        regex: 'The field format just allowed number and ( ) + -'
      }
    });
  }
})

Vue.directive('website', {
  update(el) {
    $(el).rules('add', {
      regex: '^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-]*$',
      messages: {
        regex: 'The field format is website ex(www.test.tw)'
      }
    });
  }
})

Vue.directive('amount', {
  update(el) {
    $(el).rules('add', {
      regex: '^[^.\d]+|[\d+\.]{2,}$',
      messages: {
        regex: 'Please enter a valid amount type.'
      }
    });
  }
})

Vue.directive('regex', {
  update(el, binding) {
    $(el).rules('add', {
      regex: binding.value.regex,
      messages: {
        regex: binding.value.message
      }
    });
  }
})

Vue.directive('radio', {
  inserted(el, binding) {
    let message = "This is a required field";
    if (binding.value.isRequired) {
      if (binding.value.message) {
        message = binding.value.message;
      }
      $(el, binding).rules('add', {
        required: true,
        messages: {
          required: message
        }
      });
    }
  }
})

// Vue.directive('multiselect', {
//   inserted(el, binding) {
//     var $this = $(el),
//       opts = {};

//     var pluginOptions = binding.value;
//     if (pluginOptions) opts = pluginOptions;

//     $this.themePluginMultiSelect(opts);
//   }
// })


// WEBPACK FOOTER //
// ./src/directives.js